import { render } from "./open-spots-badge.vue?vue&type=template&id=18caf903"
import script from "./open-spots-badge.vue?vue&type=script&lang=js"
export * from "./open-spots-badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__